import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
export const VerifySuccess = loadable(() => import('./verifySuccess'));
